<template>
  <section v-if="showModal" class="modal" :class="{ 'can-overflow': overflow }">
    <div @click="close()" class="overlay"></div>

    <div
      v-bind:class="{
        'large-box': largebox,
        'full-box': fullbox,
        'modal-box': !largebox,
        'guide-box': guidebox,
        'alert-box': alertBox,
        proPlanModal: proPlanModal,
        shareChannel: shareChannel,
      }"
    >
      <a @click="close()" v-if="!notClose" class="close">×</a>
      <div v-if="auxTitle" class="title">
        <h3>{{ auxTitle }}</h3>
      </div>

      <div class="modal-content">
        <slot name="content"></slot>
      </div>

      <div class="modal-action">
        <slot name="action"></slot>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "modal",
  props: {
    show: {
      default: false,
      required: true,
    },
    title: {
      default: "",
      required: false,
    },
    alertBox: {
      default: false,
    },
    largebox: {
      default: false,
    },
    fullbox: {
      default: false,
    },
    guidebox: {
      default: false,
    },
    proPlanModal: {
      default: false,
    },
    shareChannel: {
      default: false,
    },
    notClose: {
      default: false,
    },
    overflow: {
      default: false,
    },
  },
  data() {
    return {
      showModal: false,
      auxTitle: '',
    };
  },
  watch: {
    show(value) {
      this.showModal = value;
    },
    title(value) {
      this.auxTitle = value
    }
  },
  mounted() {
    this.showModal = this.show;
    this.auxTitle = this.title;
  },
  methods: {
    close() {
      if (this.notClose) {
        return;
      }
      this.showModal = false;
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
section.modal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;

  &.can-overflow {
    .modal-box {
      overflow: visible;
    }
  }

  @media only screen and (max-width: 1366px) {
    .button + .button {
      margin-left: 0;
    }
  }
  .overlay {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(#050505, 0.8);
    z-index: -1;
  }
  .modal-box {
    width: 90%;
    max-width: 650px;
    max-height: 95vh;
    padding: 40px 50px;
    position: relative;
    overflow-y: scroll;
    background: var(--boxbg);
    z-index: 998;
    box-shadow: 0 3px 15px rgba(black, 0.4);
    border-radius: 8px;
    a.close {
      font-size: 28px;
      position: absolute;
      right: 20px;
      top: 10px;
      cursor: pointer;
    }

    .title {
      text-align: center;
      margin-bottom: 40px;
      &.less-margin {
        margin-bottom: 30px;
      }
      h3 {
        font-size: 1.9rem;
        font-weight: 600;
      }
      p {
        max-width: 500px;
        margin: 5px auto 0;
        font-size: 1.7rem;
        opacity: 0.8;
      }

      &.w-icon {
        i[class*="fa-"] {
          font-size: 40px;
          opacity: 0.5;
          margin-bottom: 20px;
        }
        p {
          margin-top: 10px;
        }
      }
    }

    .content {
      font-size: 1.6rem;
      padding: 0 20px 10px;
      line-height: 1.5;
      p + p {
        margin-top: 15px;
      }
      form {
        text-align: left;
      }
    }
  }

  .alert-box {
    max-width: 450px;
  }
  .full-box {
    max-width: 100%;
    max-height: 100%;
    height: 90%;
    max-height: 95vh;
    padding: 20px 10px;
    position: relative;
    overflow-y: scroll;
    background: var(--boxbg);
    z-index: 99;
    box-shadow: 0 3px 15px rgba(black, 0.4);
    border-radius: 8px;
    a.close {
      font-size: 28px;
      position: absolute;
      right: 20px;
      top: 10px;
      cursor: pointer;
    }

    .title {
      text-align: center;
      margin-bottom: 20px;
      &.less-margin {
        margin-bottom: 30px;
      }
      h3 {
        font-size: 2.3rem;
        font-weight: 600;
      }
      p {
        max-width: 500px;
        margin: 5px auto 0;
        font-size: 1.7rem;
        opacity: 0.8;
      }

      &.w-icon {
        i[class*="fa-"] {
          font-size: 40px;
          opacity: 0.5;
          margin-bottom: 20px;
        }
        p {
          margin-top: 10px;
        }
      }
    }

    .content {
      font-size: 1.6rem;
      padding: 0 20px 10px;
      text-align: center;
      line-height: 1.5;
      text-align: center;
      p + p {
        margin-top: 15px;
      }
      form {
        text-align: left;
      }
    }
  }
  .large-box {
    width: 90%;
    max-width: 1080px;
    max-height: 95vh;
    padding: 20px 10px;
    position: relative;
    overflow-y: scroll;
    background: var(--boxbg);
    z-index: 99;
    box-shadow: 0 3px 15px rgba(black, 0.4);
    border-radius: 8px;
    a.close {
      font-size: 28px;
      position: absolute;
      right: 20px;
      top: 10px;
      cursor: pointer;
    }

    .title {
      text-align: center;
      margin-bottom: 20px;
      &.less-margin {
        margin-bottom: 30px;
      }
      h3 {
        font-size: 2.3rem;
        font-weight: 600;
      }
      p {
        max-width: 500px;
        margin: 5px auto 0;
        font-size: 1.7rem;
        opacity: 0.8;
      }

      &.w-icon {
        i[class*="fa-"] {
          font-size: 40px;
          opacity: 0.5;
          margin-bottom: 20px;
        }
        p {
          margin-top: 10px;
        }
      }
    }

    .content {
      font-size: 1.6rem;
      padding: 0 20px 10px;
      text-align: center;
      line-height: 1.5;
      text-align: center;
      p + p {
        margin-top: 15px;
      }
      form {
        text-align: left;
      }
    }
  }

  .guide-box {
    max-height: 95vh;
    max-width: 860px;
    padding: 20px 25px;
    overflow-y: auto;

    a.close {
      font-size: 28px;
      position: absolute;
      right: 10px;
      top: 0px;
      cursor: pointer;
    }

    /*responsive video*/
    .video-container {
      position: relative;
      padding-bottom: 56.25%;
      overflow: hidden;
    }
    .video-container iframe,
    .video-container object,
    .video-container embed,
    .video-container .nun-clica,
    .video-container #iframao,
    .video-container .thumb {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
    }
  }
  .proPlanModal {
    padding: 0px;
  }

  .shareChannel {
    max-width: 1200px;
    text-align: left;
    padding: 40px 50px 20px 50px;

    .modal-content {
      .content {
        text-align: left;
      }
    }

    .title {
      margin-bottom: var(--spacing-m);
    }
  }
}
</style>
